import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { logout } from '../utils/AuthService';
import './UserProfile.css';

const UserProfile = (props) => {
  const { loading, display_name, images, external_urls } = props.user;
  const imageUrl = images[0] ? images[0].url : "";
  
  // if we're still loading, indicate such
  if (loading) {
    return <h2>Loading...</h2>;
  }
  return (
    <div className="container">
      <div className="profile">
        <div className="profile_photo">
          <img src={imageUrl} alt="Profile" />
        </div>
        <div className="profile_detail">
          <h2>{`Logged in as ${display_name}`}</h2>
          Spotify URI: <a href={external_urls.spotify}>{external_urls.spotify}</a>
          <br />
          <Link to="/playlists">View Playlists</Link>
          <br />
          <a href="" onClick={logout}>Logout?</a>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state, ownProps){
  return {
    user: state.currentUser.user
  };
}

export default connect(mapStateToProps)(UserProfile);


// WEBPACK FOOTER //
// ./src/components/UserProfile.js